var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 255 63.8",
    style: {
      enableBackground: "new 0 0 255 63.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A4A",
    d: "M163.4,63.8h-10.8c-2,0-3.7-1.6-3.7-3.7V31.7l-18.9,11.8c-1.6,1-3.6,1-5.2,0L106,31.7v28.4 c0,2-1.6,3.7-3.7,3.7H91.6c-2,0-3.7-1.6-3.7-3.7l0,0V5.3c0-2.7,2.2-4.9,4.9-4.9c1,0,1.9,0.3,2.7,0.9l29.8,20.5 c1.2,0.9,2.9,0.9,4.1,0l29.8-20.5c2.2-1.5,5.3-0.9,6.8,1.3c0.6,0.8,0.8,1.8,0.9,2.7v54.8C167,62.1,165.4,63.8,163.4,63.8 C163.4,63.8,163.4,63.8,163.4,63.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A4A",
    d: "M71.8,63.7h-67c-2.7,0-4.9-2.2-4.9-4.9c0,0,0,0,0,0V3.7C0,1.6,1.6,0,3.7,0h10.8c2,0,3.7,1.6,3.7,3.7l0,0v41.9 h40.6V3.7c0-2,1.6-3.7,3.7-3.7H73c2,0,3.7,1.6,3.7,3.7v55.1C76.7,61.5,74.5,63.7,71.8,63.7L71.8,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A4A",
    d: "M183.2,0h67c2.7,0,4.9,2.2,4.9,4.9V60c0,2-1.6,3.7-3.6,3.7c0,0,0,0,0,0h-10.8c-2,0-3.7-1.6-3.7-3.7 c0,0,0,0,0,0V20.5c0-1.3-1.1-2.4-2.4-2.4l0,0h-35.7c-1.3,0-2.4,1.1-2.4,2.4c0,0,0,0,0,0V60c0,2-1.6,3.7-3.7,3.7H182 c-2,0-3.7-1.6-3.7-3.7c0,0,0,0,0,0V4.9C178.3,2.2,180.5,0,183.2,0C183.2,0,183.2,0,183.2,0L183.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A4A",
    d: "M211.3,29.7H222c2,0,3.7,1.6,3.7,3.7v10.9c0,2-1.6,3.7-3.7,3.7h-10.7c-2,0-3.7-1.6-3.7-3.7V33.3 C207.6,31.3,209.3,29.7,211.3,29.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUma);
export default __webpack_public_path__ + "static/media/uma.e24494adf884a970423c2d2146f7bf09.svg";
export { ForwardRef as ReactComponent };